import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import ProductCard from "../components/ProductCard";

const CATEGORIES = ["Todo", "Bolsos", "Ropa", "Accesorios"];

export default function Catalog() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialCat = searchParams.get("cat") || "Todo";
  const [active, setActive] = useState(initialCat);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = active === "Todo" ? {} : { category: active };
    api
      .get("/products", { params })
      .then((res) => setProducts(res.data))
      .finally(() => setLoading(false));
  }, [active]);

  const handleSelect = (cat) => {
    setActive(cat);
    if (cat === "Todo") setSearchParams({});
    else setSearchParams({ cat });
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16" data-testid="catalog-page">
      <div className="text-center mb-12">
        <div className="label-tracked text-[#C27A62] mb-3">La colección</div>
        <h1 className="font-serif-editorial text-5xl md:text-6xl text-[#1E1E1E]">
          Colección
        </h1>
        <p className="text-[#5C5C5C] mt-4 max-w-xl mx-auto">
          Cada pieza es única. Si algo te enamora, escríbeme y te confirmo
          disponibilidad.
        </p>
      </div>

      <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-12 border-b border-[#E5E0D8] pb-6">
        {CATEGORIES.map((c) => (
          <button
            key={c}
            onClick={() => handleSelect(c)}
            data-testid={`filter-${c.toLowerCase()}`}
            className={`label-tracked px-5 py-2 transition-colors ${
              active === c
                ? "bg-[#1E1E1E] text-[#F9F6F0]"
                : "text-[#1E1E1E] hover:text-[#C27A62]"
            }`}
          >
            {c}
          </button>
        ))}
      </div>

      {loading ? (
        <p className="text-center text-[#5C5C5C]">Cargando...</p>
      ) : products.length === 0 ? (
        <p className="text-center text-[#5C5C5C] py-20">
          No hay piezas en esta categoría todavía.
        </p>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8">
          {products.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </div>
  );
}
